import {Panel, PanelSection} from "../../contenful/types";
import "./styles/PanelSectionComponent.scss";
import React, {useEffect} from "react";
import {cloneSlideStart, navigatePagination, prevNextArrowPosition, slideTransform} from "../../utils/SlideNext";
import PanelSectionFixedWidth from './PanelSectionFixedWidth';
import PanelSectionFullWidth from './PanelSectionFullWidth';


interface Props {
    section : PanelSection;
    mobile : boolean;
    loggedIn? : boolean;
}

const PanelSectionComponent: React.FC<Props> = (props : Props) => {

    useEffect(() => {
        // Fixed-Width Clone Slides
        const getFixedWidthPanelWrapperDesktop = document.querySelectorAll<HTMLElement>(`.container-fixed-width .panel-wrapper.desktop`)
        for(let a = 0; a < getFixedWidthPanelWrapperDesktop.length; a++) {
            const idDiv = getFixedWidthPanelWrapperDesktop[a].getAttribute('id')
            if(props.section._id === idDiv) {
                const getDiv = getFixedWidthPanelWrapperDesktop[a]
                for(let i = 1; i < 7; i++) {
                    cloneSlideStart(getDiv)
                }
            }
        }

        // Fixed-Width Slides Init Position
        slideTransform(getFixedWidthPanelWrapperDesktop && getFixedWidthPanelWrapperDesktop, -6, undefined, undefined, undefined, undefined, undefined)

        // Fixed-Width Pagination
        for(let i = 0; i < getFixedWidthPanelWrapperDesktop.length; i++) {
            navigatePagination(getFixedWidthPanelWrapperDesktop[i])
        }

       return () => {

        };
    }, []);

    useEffect(() => {
        // Full-Width Clone Slides
        const getFullWidthPanelWrapper = document.querySelectorAll<HTMLElement>(`.container-full-width .panel-wrapper`)

        for(let a = 0; a < getFullWidthPanelWrapper.length; a++) {
            const idDiv = getFullWidthPanelWrapper[a].getAttribute('id')
            if(props.section._id === idDiv) {
                const getDiv = getFullWidthPanelWrapper[a]
                for(let i = 1; i < 3; i++) {
                    cloneSlideStart(getDiv)
                }
            }
        }

        // Full-Width Prev-Next Arrow Position
        prevNextArrowPosition(getFullWidthPanelWrapper && getFullWidthPanelWrapper, false, false)

        // Full-Width Slides Init Position
        slideTransform(getFullWidthPanelWrapper && getFullWidthPanelWrapper, -2, undefined, undefined, undefined, undefined, undefined)

        // Full-Width Pagination
        for(let i = 0; i < getFullWidthPanelWrapper.length; i++) {
            navigatePagination(getFullWidthPanelWrapper[i])
        }
       return () => {

        };
    }, []);

    const clickingPrev = (id: any, slideTransformInit: number, wrapperClassName: string) => {
        setTimeout(() => {
            const getPanelWrapper = document.querySelectorAll<HTMLElement>(`${wrapperClassName}`)
            for(let i = 0; i < getPanelWrapper.length; i++) {
                const getWrapperId = getPanelWrapper[i].getAttribute('id')
                if(getWrapperId && getWrapperId === id) {
                    slideTransform(getPanelWrapper && getPanelWrapper, -1, id, false, true, false, slideTransformInit)
                    navigatePagination(getPanelWrapper[i])
                }
            }
        }, 10)
    }

    const clickingNext = (id: any, wrapperClassName: string) => {
        setTimeout(() => {
            const getPanelWrapper = document.querySelectorAll<HTMLElement>(`${wrapperClassName}`)
            for(let i = 0; i < getPanelWrapper.length; i++) {
                const getWrapperId = getPanelWrapper[i].getAttribute('id')
                if(getWrapperId && getWrapperId === id) {
                    slideTransform(getPanelWrapper && getPanelWrapper, 1, id, false, false, true, undefined)
                    navigatePagination(getPanelWrapper[i])
                }
            }
        }, 10)
    }

    const renderNavigate = (clickPrevFunction: any, clickNextFunction: any,  panels : Panel[], bottomNavigation? : boolean) => {
        if(bottomNavigation) {
            return (
                <div className={`navigate-wrapper navigate-bottom`}>
                    <button type="button" className="navigate-prev" onClick={clickPrevFunction}>
                        <svg className="icon icon-arrowLeft" viewBox="0 0 24 24" width="24px" height="24px">
                            <title>Arrow Left</title>
                            <path d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                        </svg>
                    </button>
                    <ul className={`splide-pagination`}>
                        {panels.map((item: any, idx: any) => {
                            return <li key={idx}>
                                <button className={`splide-pagination-page`} type="button"></button>
                            </li>
                        })
                        }
                    </ul>
                    <button type="button" className="navigate-next" onClick={clickNextFunction}>
                        <svg className="icon icon-arrowRight" viewBox="0 0 24 24" width="24px" height="24px">
                            <title>Arrow Right</title>
                            <path d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                        </svg>
                    </button>
                </div>
            )
        }

        return <div className={`navigate-wrapper`}>
            <button type="button" className="navigate-prev" onClick={clickPrevFunction}>
                <svg className="icon icon-arrowLeft" viewBox="0 0 24 24" width="24px" height="24px">
                    <title>Arrow Left</title>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                </svg>
            </button>
            <button type="button" className="navigate-next" onClick={clickNextFunction}>
                <svg className="icon icon-arrowRight" viewBox="0 0 24 24" width="24px" height="24px">
                    <title>Arrow Right</title>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"></path>
                </svg>
            </button>
                </div>
    }

    const items = props.section && props.section.panels && props.section.panels.length
    let bottomNavigation = props.section.type === 'panel-section-bottom-navigation';
    
    return (
        <>
        {props.section && props.section._id && props.section.panels && props.section.fullWidth &&
            <PanelSectionFullWidth loggedIn={props.loggedIn} id={props.section._id}
            sectionClassName={props.section.cssClassName ? props.section.cssClassName : ''}
            itemLength={items}
            panels={props.section.panels}
            bottomNavigation={bottomNavigation}
            renderNavigate={renderNavigate(clickingPrev.bind('', props.section._id, 2, '.container-full-width .panel-wrapper'), clickingNext.bind('', props.section._id, '.container-full-width .panel-wrapper'), props.section.panels, bottomNavigation)} />
        }
        {props.section && props.section._id && props.section.panels && !props.section.fullWidth &&
            <PanelSectionFixedWidth loggedIn={props.loggedIn} id={props.section._id}
            sectionClassName={props.section.cssClassName ? props.section.cssClassName : ''}
            itemLength={items}
            panels={props.section.panels}
            renderNavigate={renderNavigate(clickingPrev.bind('', props.section._id, 6, '.container-fixed-width .panel-wrapper.desktop'), clickingNext.bind('', props.section._id, '.container-fixed-width .panel-wrapper.desktop'), props.section.panels, bottomNavigation)} />
        }
        </>
    )
}

export default PanelSectionComponent;
